
import TableList from "@components/templates/tablelist";
import { HttpGetOrderList, HttpGetOrderSubmit, HttpGetOrderCancel, HttpGetOrderDelete, HttpGetOrderNotes, HttpGetOrderClose, HttpBatchInspection, HttpResetOrder, HttpFindProvidersByOrg, HttpGetAuditing, HttpGetCountPoOrder, HttpGetContract, HttpRemoveError, HttpExportPrice, HttpGetDingStatus, HttpBackSubmit } from "@/service/purchase/purchase";
import { mapState, mapGetters } from "vuex";
import comIndex from './update/index'
import delivery from './update/delivery'
import comInspection from './update/inspection'
import comReplenish from './update/replenish'
import comCantract from './update/contract'
import comExcel from '@components/templates/excelalert'
import compLock from "./lock.vue";

export default {
    mixins: [TableList],
    components: {
        comIndex,
        delivery,
        comInspection,
        comReplenish,
        comCantract,
        comExcel,
        compLock
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            spanTabs: { show: true },
            funderList: [],
            formData: {
                search: {
                    'quanbu': 0,
                }
            },
            exportdata: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            keyword: this.$route.query.keyword,
            isSuper: this.$store.state.userinfo.isSuper,
            isShenhe: false
        };
    },
    /**
     *  增加防止出现为entity
     */
    created() {
        // (async () => {
            HttpFindProvidersByOrg().then(
                (res) => {
                    this.funderList =
                        res.data ||
                        [];
                },
                (err) => {
                    // this.$VMessage.error(err.message)
                    this.funderList = [];
                }
            );
        // })()
        this.showFKbtu = this.handleAuth('erp.po_order.replace_to_fk');
    },
    mounted() {
        this.$set(this.$refs.compSearchs.formData, 'EQ_keyword', this.keyword)
        if (this.keyword) {
            this.$set(this.$refs.compSearchs, 'show', true)
        }
    },
    methods: {
        ajaxRequest: HttpGetOrderList,
        spanAjaxRequest: HttpGetCountPoOrder,
        toolsRender() { //自定义工具行
            return <div class="back-fff padding-10 margin-bottom-10">
                <vButton class="margin-right-5" theme="primary" nativeOnClick={this.handleOperates.bind(this, '', 'add')}>{this.$t("boss.purchase.add",{defaultValue:"新增"})}</vButton>
                <Dropdown class="margin-right-5">
                    <Button >
                        {this.$t("boss.purchase.more_operations",{defaultValue:"更多操作"})}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'submitbox', true)}>{this.$t("boss.purchase.batch_submission",{defaultValue:"批量提交"})}</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'auditingpass', true)}>{this.$t("boss.purchase.batch_review_passed",{defaultValue:"批量审核通过"})}</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'close', true)}>{this.$t("boss.purchase.batch_completion",{defaultValue:"批量完成"})}</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'notes', true)}>{this.$t("boss.purchase.batch_add_notes",{defaultValue:"批量添加备注"})}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown class="margin-right-5">
                    <Button type="info">
                        {this.$t("boss.purchase.batch_import",{defaultValue:"批量导入"})}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'batchinspection')}>{this.$t("boss.purchase.batch_import_inspection",{defaultValue:"批量导入验货"})}</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'batchdelivery')}>{this.$t("boss.purchase.batch_import_delivery",{defaultValue:"批量导入交货"})}</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'batchPrice')}>{this.$t("boss.purchase.batch_import_export_prices",{defaultValue:"批量导入外销价格"})}</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'batchFirm')}>{this.$t("boss.purchase.batch_import_Firm",{defaultValue:"批量导入Firm"})}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown class="margin-right-5">
                    <Button type="success">
                        {this.$t("boss.purchase.export_query_conditions",{defaultValue:"查询条件导出"})}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'exportExcel')}>{this.$t("boss.purchase.export_purchase_details",{defaultValue:"导出采购明细"})}</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'exportinspection')}>{this.$t("boss.purchase.export_delivery_details",{defaultValue:"导出交货明细"})}</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this, '', 'exportprice')}>{this.$t("boss.purchase.export_export_prices",{defaultValue:"导出外销价格"})}</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('boss.purchase.select_data',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    {
                        this.$router.push({
                            name: 'purchaseOrderUpdate',
                            params: { type: "add" },
                            // query: { id: params },
                        });
                    }
                    break;
                case "edit":
                    {
                        var url = this.$router.resolve({
                            name: "purchaseOrderUpdate",
                            params: { type: "edit" },
                            query: { id: params },
                        });
                        window.open(url.href, '_blank');
                    }
                    break;
                case 'exportExcel':
                    {
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/po/exportDetail", {
                            ...this.exportdata,
                            showmessage:'no'
                        }, {
                            executor: 'request',
                            download: true,
                        }).then(res=>{
                            this.operate = {
                                title: this.$t('boss.purchase.purchase_details_export',{defaultValue:'采购明细导出'}),
                                show: true,
                                width: 560,
                                component: "comExcel",
                                showFooter: false
                            }
                        }).catch(err => {
                            // this.$VMessage.error(err.message);
                        })
                    }
                    break
                case 'exportinspection':
                    {
                        // let searchdata2 = this.handleParams(params)
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/po/exportDeliver", {
                            ...this.exportdata,
                            showmessage:'no'
                        }, {
                            executor: 'request',
                            download: true,
                        }).then(res=>{
                            this.operate = {
                                title: this.$t('boss.purchase.export_delivery_details',{defaultValue:'导出交货明细'}),
                                show: true,
                                width: 560,
                                component: "comExcel",
                                showFooter: false
                            }
                        }).catch(err => {
                            // this.$VMessage.error(err.message);
                        })
                    }
                    break
                case "delivery":
                    {
                        this.operate = {
                            title: this.$t('boss.purchase.delivery',{defaultValue:'交货'}),
                            show: true,
                            width: 1200,
                            component: "delivery",
                            activeid: params,
                            querytype: 'delivery',
                            showFooter: false
                        }
                    }
                    break;
                case "query":
                    {
                        this.operate = {
                            title: this.$t('boss.purchase.view',{defaultValue:'查看'}),
                            show: true,
                            width: 1200,
                            component: "comIndex",
                            activeid: params,
                            querytype: 'query',
                            showFooter: false
                        }
                    }
                    break;
                case "queryBlank":
                    {
                        var url = this.$router.resolve({
                            name: "purchaseOrderUpdate",
                            params: { type: "query" },
                            query: { id: params },
                        });
                    }
                    window.open(url.href, '_blank');
                    break;

                case "jumpinbound":
                    {
                        var url = process.env.VUE_APP_FBB + '/home/inbound/billclient/update/query?id=' + params;
                        window.open(url, '_blank');
                    }
                    break;
                case "submitbox":
                    {
                        console.log(params);
                        let isDing = params.paymentType == 'payment' || params.paymentType == 'fk';
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('boss.purchase.submit',{defaultValue:'提交'}),
                            width: 460,
                            params: { ids: params.id },
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                    labelWidth: 150,
                                    required: false,
                                },
                                {
                                    tag: "vCheckbox",
                                    key: "dingProcessEnable",
                                    show: global.SYSID == 1,
                                    span: 24,
                                    label: this.$t('boss.purchase.submit_Ding_Talk',{defaultValue:'同时提交钉钉申请流程'}),
                                    labelWidth: 150,
                                    default: isDing,
                                    required: false
                                }
                            ],
                            ajaxRequest: HttpGetOrderSubmit,
                            interceptRequest: (params) => {
                                params.dingProcessEnable = params.dingProcessEnable ? 1 : 0;
                                return params;
                            }
                        }
                    };
                    break;
                case "delete":
                    {
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('boss.purchase.delete',{defaultValue:'删除'}),
                            width: 460,
                            params: { ids: params },
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                    required: false,
                                }
                            ],
                            ajaxRequest: HttpGetOrderDelete
                        };
                    }
                    break;
                case "close":
                    {
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('boss.purchase.complete',{defaultValue:'完成'}),
                            width: 460,
                            params: { ids: params },
                            desc: this.$t('boss.purchase.after_completion',{defaultValue:'完成后，采购未发运数量清零，请谨慎操作！'}),
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                    required: false,
                                }
                            ],
                            ajaxRequest: HttpGetOrderClose
                        };
                    }
                    break;
                case "cancel":
                    {
                        let that = this;
                        function showCancelModal () {
                            that.operate = {
                                show: true,
                                alert: "error",
                                title: this.$t('boss.purchase.cancel_document',{defaultValue:'取消单据'}),
                                width: 460,
                                params: { ids: params },
                                formdata: [
                                    {
                                        tag: "vTextarea",
                                        key: "remark",
                                        span: 24,
                                        label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                        required: false,
                                    }
                                ],
                                ajaxRequest: HttpGetOrderCancel
                            };
                        }
                        HttpGetDingStatus({
                            id: params
                        }).then(res => {
                            if (res.message) {
                                this.operate = {
                                    show: true,
                                    alert: "warning",
                                    title: this.$t('boss.purchase.be_careful',{defaultValue:'注意'}),
                                    desc: this.$t('boss.purchase.the_submitted_DingTalk',{defaultValue:'提交的钉钉流程已完结，钉钉流程无法取消，请注意！'}),
                                    ajaxRequest: async () => {
                                        await (this.operate.show = false)
                                    },
                                    callback: showCancelModal
                                }
                            }
                            else {
                                showCancelModal();
                            }
                        }, err => {
                            this.$VMessage.error(err.message);
                        });
                        
                    }
                    break;

                case "notes":
                    {
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('boss.purchase.add_note',{defaultValue:'添加备注'}),
                            width: 460,
                            params: { ids: params },
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                    required: false,
                                }
                            ],
                            ajaxRequest: HttpGetOrderNotes
                        };
                    }
                    break;
                case "inspection":
                    {
                        this.operate = {
                            title: this.$t('boss.purchase.inspection',{defaultValue:'验货'}),
                            show: true,
                            width: 1200,
                            component: "comInspection",
                            activeid: params.id,
                            showFooter: false
                        }
                    }
                    break;
                case "reset":
                    {
                        let that = this;
                        function showResetModal () {
                            that.operate = {
                                show: true,
                                alert: "error",
                                title: this.$t('boss.purchase.purchase_order_reset',{defaultValue:'采购单重置'}),
                                desc: this.$t('boss.purchase.after_resetting',{defaultValue:'重置后，单据将变为草稿状态！'}),
                                width: 460,
                                params: { id: params },
                                formdata: [
                                    {
                                        tag: "vTextarea",
                                        key: "remark",
                                        span: 24,
                                        label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                    }
                                ],
                                ajaxRequest: HttpResetOrder,
                            };
                        }
                        HttpGetDingStatus({
                            id: params
                        }).then(res => {
                            if (res.message) {
                                this.operate = {
                                    show: true,
                                    alert: "warning",
                                    title: this.$t('boss.purchase.be_careful',{defaultValue:'注意'}),
                                    desc: this.$t('boss.purchase.the_submitted_DingTalk',{defaultValue:'提交的钉钉流程已完结，钉钉流程无法取消，请注意！'}),
                                    ajaxRequest: async () => {
                                        await (this.operate.show = false)
                                    },
                                    callback: showResetModal
                                }
                            }
                            else {
                                showResetModal();
                            }
                        }, err => {
                            this.$VMessage.error(err.message);
                        });
                    }
                    break;
                case "auditingpass":
                    {
                        this.operate = {
                            show: true,
                            alert: "primary",
                            title: this.$t('boss.purchase.approved',{defaultValue:'审核通过'}),
                            width: 460,
                            params: { ids: params, orderStatus: 'auditing_pass' },
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                    required: false,
                                }
                            ],
                            ajaxRequest: HttpGetAuditing
                        };
                    }
                    break;
                case "auditingrefused":
                    {
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('boss.purchase.review_rejected',{defaultValue:'审核驳回'}),
                            width: 460,
                            params: { ids: params, orderStatus: 'auditing_refused' },
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                    required: false,
                                }
                            ],
                            ajaxRequest: HttpGetAuditing
                        };
                    }
                    break;

                case "batchinspection":
                    {
                        this.operate = {
                            width: 450,
                            show: true,
                            title: this.$t('boss.purchase.batch_import_inspection',{defaultValue:'批量导入验货'}),
                            showDesc: false,
                            component: "compUpload",
                            name: "excelFile",
                            showFooter: false,
                            action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/po/importInspectExcel",
                            download: () => {
                                this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/po/downInspectExcel', {}, 'download')
                            },
                        };
                    }
                    break;
                case "batchdelivery":
                    {
                        this.operate = {
                            width: 450,
                            show: true,
                            title: this.$t('boss.purchase.batch_import_delivery',{defaultValue:'批量导入交货'}),
                            showDesc: false,
                            component: "compUpload",
                            name: "excelFile",
                            warningtitle: this.$t('boss.purchase.supplement_financial',{defaultValue:'该导入为覆盖更新，如果有过交货记录，导入后将以新数据覆盖！'}),
                            showFooter: false,
                            action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/po/importBatchDeliverExcel",
                            download: () => {
                                this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/po/downBatchDeliverExcel', {}, 'download')
                            },
                        };
                    }
                    break;
                case 'replenish':
                    {
                        this.operate = {
                            // width: 800,
                            width: 1200,
                            show: true,
                            title: this.$t('boss.purchase.batch_import_delivery',{defaultValue:'补充金融风控信息'}),
                            // showDesc: false,
                            showFooter: false,
                            activeid: params,
                            component: "comReplenish",
                            on: {
                                'on-success': () => {
                                    this.operate.show = false;
                                    this.startUp ++;
                                }
                            }
                        }
                    }
                    break;
                case 'downcontract':
                    {
                        this.operate = {
                            title: this.$t('boss.purchase.download_contract',{defaultValue:'下载合同'}),
                            show: true,
                            width: 450,
                            component: "comCantract",
                            activeid: params,
                            querytype: 'query',
                            showFooter: false
                        }
                    }
                break;
                case 'delError':
                    {
                        this.operate = {
                            show: true,
                            alert: "error",
                            title: this.$t('boss.purchase.remove_anomalies',{defaultValue:'去除异常'}),
                            width: 460,
                            params: { ids: params },
                            formdata: [
                                {
                                    tag: "vTextarea",
                                    key: "remark",
                                    span: 24,
                                    label: this.$t('boss.purchase.reason_remark',{defaultValue:'备注原因'}),
                                }
                            ],
                            ajaxRequest: HttpRemoveError
                        };
                    }
                break;
                case "cancelSubmit":
                    this.operate = {
                        show: true,
                        title: this.$t('boss.purchase.withdraw_submission',{defaultValue:'撤回提交'}),
                        alert: "warning",
                        showFooter: true,
                        width: 460,
                        params: { ids: params },
                        formdata: [
                            {
                                label: this.$t('boss.purchase.notes',{defaultValue:'备注'}),
                                key: "remark",
                                tag: "vTextarea",
                                span: 24,
                                required: false
                            }
                        ],
                        ajaxRequest: HttpBackSubmit
                    }
                    break;
                case 'batchPrice':
                    {
                        this.operate = {
                            show: true,
                            title: this.$t('boss.purchase.batch_import_export_prices',{defaultValue:'批量导入外销价格'}),
                            width: 460,
                            component: 'compMutiUpload',
                            showFooter: false,
                            action: process.env.VUE_APP_APIURL_BOSS + '/api/v2/po/importExportPriceExcel',
                            name: "excelFile",
                            multiple: false,
                            download: () => {this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/po/downExportPriceExcel", {}, 'download')},
                            formatter: (res) => {
                                this.$VMessage.success(res.message);
                                this.operate.show = false;
                            },
                            warningtitle: this.$t('boss.purchase.text_align',{defaultValue:'<div style="text-align: left;position: relative;left: -40px;">1.只支持修改采购单的外销价格<br/>2.已经入库并计算过成本的产品，外销价格需要进成本模块手动调整<br/>3.没有入库并计算成本的产品，会按修改后的外销价格计算成本</div>'}),
                            on:{
                                // 'on-success':(res)=>{
                                //     console.log(res);
                                //     this.operate.show = false;
                                // },
                                'on-cancel':()=>{
                                    this.operate.show = false;
                                }
                            },
                        }
                    }
                break;
                // 导出外销价格
                case 'exportprice':
                    HttpExportPrice(this.handleParams(this.formData)).then(res => {
                        this.operate = {
                            title: this.$t('boss.purchase.export_delivery_details',{defaultValue:'导出交货明细'}),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    }, err => {
                        this.$VMessage.error(err.message);
                    });
                break;
                // 导入firm
                case 'batchFirm':
                    this.operate = {
                        width: 450,
                        show: true,
                        title: this.$t('boss.purchase.import_Firm',{defaultValue:'导入Firm'}),
                        component: "compUpload",
                        name: "excelFile",
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/po/importItemFirmExcel",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/po/downItemFirmExcel', {}, 'download')
                        },
                    };
                break;
            }
        },
        getOperateNodeMap(row) {
            const { id, orderStatus, expectedInspectDate, inboundPlanReceiveList, errorCode } = row
            return [{
                label: this.$t('boss.purchase.submit',{defaultValue:'提交'}),
                show: orderStatus == 'draft' || orderStatus == 'auditing_refused',
                params: row,
                operate: 'submitbox'
            }, {
                label: this.$t('boss.purchase.view',{defaultValue:'查看'}),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('boss.purchase.edit',{defaultValue:'编辑'}),
                show: orderStatus == 'draft' || orderStatus == 'auditing_refused',
                params:id,
                operate:'edit'
                // to: {
                //     name: 'purchaseOrderUpdate',
                //     params: { type: 'edit' },
                //     query: { id },
                // },
            }, {
                label: this.$t('boss.purchase.cancel',{defaultValue:'取消'}),
                show: orderStatus == 'submit' || orderStatus == 'auditing_pass' || orderStatus == 'auditing_refused',
                params: id,
                operate: 'cancel'
            },
            {
                label: this.$t('boss.purchase.approved',{defaultValue:'审核通过'}),
                show: orderStatus == 'submit',
                params: id,
                operate: 'auditingpass'
            },
            {
                label: this.$t('boss.purchase.review_rejected',{defaultValue:'审核驳回'}),
                show: orderStatus == 'submit',
                params: id,
                operate: 'auditingrefused'
            },
            {
                label: this.$t('boss.purchase.manually_complete_document',{defaultValue:'手动完成单据'}),
                show: orderStatus == 'auditing_pass' && inboundPlanReceiveList,
                params: id,
                operate: 'close'
            }, {
                label: this.$t('boss.purchase.delete',{defaultValue:'删除'}),
                show: orderStatus == 'draft',
                params: id,
                operate: 'delete'
            }, {
                label: this.$t('boss.purchase.add_note',{defaultValue:'添加备注'}),
                show: true,
                params: id,
                operate: 'notes'
            }, {
                label: this.$t('boss.purchase.delivery',{defaultValue:'交货'}),
                show: !(orderStatus == 'draft' || orderStatus == 'submit' || orderStatus == 'auditing_refused'),
                params: id,
                operate: 'delivery'
            }, {
                label: this.$t('boss.purchase.inspection',{defaultValue:'验货'}),
                show: orderStatus == 'auditing_pass',
                params: { id, expectedInspectDate },
                operate: 'inspection'
            }, {
                label: this.$t('boss.purchase.purchase_order_reset',{defaultValue:'采购单重置'}),
                show: orderStatus == 'auditing_pass',
                params: id,
                operate: 'reset'
            }, {
                label: this.$t('boss.purchase.supplement_financial',{defaultValue:'补充金融风控信息'}),
                show: (orderStatus === 'finished' || orderStatus === 'auditing_pass') && this.showFKbtu && row.paymentType !== 'fk',
                params: id,
                operate: 'replenish'
            },{
                label: this.$t('boss.purchase.download_contract',{defaultValue:'下载合同'}),
                show: orderStatus != 'canceled' && orderStatus != 'auditing_refused',
                params: id,
                operate: 'downcontract'
            },{
                label: this.$t('boss.purchase.remove_anomalies',{defaultValue:'去除异常'}),
                show: errorCode >= 1,
                params: id,
                operate: 'delError'
            },{
                label: this.$t('boss.purchase.withdraw_submission',{defaultValue:'撤回提交'}),
                show: orderStatus == 'submit',
                params: id,
                operate: "cancelSubmit"
            } ]
        },
        getinboundStatus(inboundStus) {
            switch (inboundStus) {
                case 5: return this.$t('fbb.inbound.check_pending', { defaultValue: '待审核' });
                case 6: return this.$t('fbb.inbound.approval_back', { defaultValue: '审批拒回' });
                case 8: return this.$t('fbb.inbound.for_packing', { defaultValue: '待装箱' });
                case 10: return this.$t('fbb.inbound.send_goods', { defaultValue: '待发货' });
                case 20: return this.$t('fbb.inbound.stock_pending', { defaultValue: '待入库' });
                case 25: return this.$t('fbb.inbound.inthe_library', { defaultValue: '入库中' });
                case 70: return this.$t('global.common.finished', { defaultValue: '已完成' });
                case 100: return this.$t('global.common.canceled', { defaultValue: '已取消' });
            }
        },
        handleParams(params) {
            // console.log(params);

            if (params.search.quanbu === 0) {
                params.search.EQ_orderStatus = '';

            }
            else if (params.search.shenhe === 0) {
                params.search.EQ_orderStatus = 'submit'
            }
            else if (params.search.yanhuo === 0) {
                params.search.EQ_orderStatus = 'auditing_pass'
                params.search.IN_inspectStatus = [0, 2]
                params.search.EQ_isNeedInspect = 1
            }
            else if (params.search.ruku === 0) {
                params.search.EQ_orderStatus = 'auditing_pass'
                params.search.EQ_inboundAvailable = 0;
            }
            else if (params.search.jiaohuo === 0) {
                params.search.EQ_orderStatus = 'auditing_pass'
                params.search.EQ_deliverStatus = 0
            }
            else if (params.search.rucang === 0) {
                params.search.EQ_orderStatus = 'auditing_pass';
                params.search['EQ_poOrderItem.isAllReceive'] = 0;
                params.search['GE_poOrderItem.shipmentQuantity'] = 1;
            }
            else if (params.search.yichang === 0) {
                params.search.GE_errorCode = 1;
            }
            else if (params.search.timeout === 0) {
                params.search.EQ_orderStatus = 'auditing_pass';
                params.search.LE_expectedFinishDate = this.getDay(0);
                 
            }

            const {CN_orderNo } = params.search;
            let IN_orderNo;
            if(CN_orderNo){
                IN_orderNo = CN_orderNo.replace(/\n/g,",");
            }
            params.search.IN_orderNo = IN_orderNo;

            delete params.search.quanbu
            delete params.search.shenhe
            delete params.search.yanhuo
            delete params.search.ruku
            delete params.search.jiaohuo
            delete params.search.rucang
            delete params.search.yichang
            delete params.search.timeout
            delete params.search.CN_orderNo;

            // 切换时间查询
            const createdAt = (params.search.GE_createdAt || "").split('~');
            params.search.GE_createdAt = createdAt[0];
            params.search.LE_createdAt = createdAt[1];

            const promiseDeliveryDate = (params.search.GE_promiseDeliveryDate || "").split('~');
            params.search.GE_promiseDeliveryDate = promiseDeliveryDate[0];
            params.search.LE_promiseDeliveryDate = promiseDeliveryDate[1];



            // console.log(params)
            this.exportdata = params
            
            // 待审核状态
            if (params.search.EQ_orderStatus == 'submit') {
                this.isShenhe = true;
            }
            else {
                this.isShenhe = false;
            }

            return params
        },
        interceptRequest(params) {
            return this.handleParams(params)
        },
    },
    computed: {
        ...mapGetters('diction', ['getNewDifferentAllProductList', 'getAllCostGroupName', 'getAllCurrency', 'getNewWarehouseIdList', 'getAllSupplier']),
        ...mapGetters('dictionary', ['getWarehouseAllList']),
        getOrderStatus() {
            return [
                {
                    value: 'draft',
                    label: this.$t('boss.purchase.draft',{defaultValue:'草稿'}),
                    theme: 'darkgray',
                },
                {
                    value: 'submit',
                    label: this.$t('boss.purchase.submitted',{defaultValue:'已提交'}),
                    theme: 'primary',
                },
                {
                    value: 'auditing_pass',
                    label: this.$t('boss.purchase.approved',{defaultValue:'审核通过'}),
                    theme: 'success'
                },
                {
                    value: 'finished',
                    label: this.$t('boss.purchase.completed',{defaultValue:'已完成'}),
                    theme: '',
                },
                {
                    value: 'canceled',
                    label: this.$t('boss.purchase.cancelled',{defaultValue:'已取消'}),
                    theme: 'warning'
                },
                {
                    value: 'auditing_refused',
                    label: this.$t('boss.purchase.review_rejected',{defaultValue:'审核驳回'}),
                    theme: 'error'
                },
            ];
        },
        buyModeList() {
            return [
                {
                    value: "payment",
                    label: this.$t('boss.purchase.self_procurement',{defaultValue:'自采'}),
                },
                {
                    value: "unpayment",
                    label: this.$t('boss.purchase.agency_operations',{defaultValue:'代运营'}),
                },
                {
                    value: "fk",
                    label: this.$t('boss.purchase.financial_procurement_agency',{defaultValue:'金融代采'}),
                },
                {
                    value: "undefined",
                    label: this.$t('boss.purchase.other',{defaultValue:'其他'}),
                },
            ]
        },
        TabsData() {
            return [
                {
                    name: this.$t('boss.purchase.all_purchase_orders',{defaultValue:'所有采购单'}),
                    key: 'quanbu',
                    val: 0,
                    spanKey: 'all',
                },
                {
                    name: this.$t('boss.purchase.pending_approval',{defaultValue:'待审核'}),
                    key: 'shenhe',
                    val: 0,
                    spanKey: 'submit',
                }, {
                    name: this.$t('boss.purchase.create_inventory_plan',{defaultValue:'待创建入库计划'}),
                    key: "ruku",
                    val: 0,
                    spanKey: 'wait_create_inbound_order_qty',
                },{
                    name: this.$t('boss.purchase.goods_awaiting_inspection',{defaultValue:'待验货'}),
                    key: "yanhuo",
                    val: 0,
                    spanKey: 'inspect_order_qty',
                }, {
                    name: this.$t('boss.purchase.to_be_delivered',{defaultValue:'待交货'}),
                    key: "jiaohuo",
                    val: 0,
                    spanKey: 'deliver_order_qty',
                }, {
                    name: this.$t('boss.purchase.pending_warehouse_entry',{defaultValue:'待入仓'}),
                    key: "rucang",
                    val: 0,
                    spanKey: 'waiting_in_depot_order_qty',
                },
                {
                    name: this.$t('boss.purchase.abnormal_order',{defaultValue:'异常单'}),
                    key: 'yichang',
                    val: 0,
                    spanKey: 'error',
                },
                {
                    name: this.$t('boss.purchase.timeout',{defaultValue:'超时'}),
                    key: "timeout",
                    val: 0,
                    spanKey: 'time_out_order_qty',
                },
            ]
        },

        SearchsData() {
            let stylewidth = "width:210px;"
            return [
                {
                    label: this.$t('boss.purchase.purchase_order_number',{defaultValue:'采购单编号'}),
                    key: 'CN_orderNo',
                    show: true,
                    tag: 'vTextarea',
                    class:"inboundtext",
                    props:{
                        placeholder: this.$t('fbb.inbound.input_more_line', { defaultValue: "输入多个，一行一个" }),
                        rows:"1",
                    }
                },
                {
                    label: this.$t('boss.purchase.document_status',{defaultValue:'单据状态'}),
                    tag: 'vSelect',
                    key: 'IN_orderStatus',
                    options: this.getOrderStatus,
                    props: {
                        multiple: true,
                    },
                    show: true,
                },
                {
                    label: this.$t('boss.purchase.project',{defaultValue:'项目'}),
                    tag: 'Select',
                    key: 'IN_lineId',
                    show: true,
                    options: this.getNewDifferentAllProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    }
                },
                {
                    label: this.$t('boss.purchase.payment_cycle',{defaultValue:'付款周期'}),
                    key: "GE_paymentDay",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    combineKey: 'paymentDay',
                    style: 'width: 95px;'
                },
                {
                    label: '~',
                    key: "LE_paymentDay",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    formItem: {
                        style: "margin-left: -90px"
                    },
                    combineKey: 'paymentDay',
                    style: 'width: 95px;'
                },

                {
                    label: this.$t('boss.purchase.prepayment_ratio',{defaultValue:'预付款比例(%)'}),
                    key: "GE_paymentRate",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    combineKey: 'paymentRate',
                    style: 'width: 95px;'
                },
                {
                    label: '~',
                    key: "LE_paymentRate",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    formItem: {
                        style: "margin-left: -90px"
                    },
                    combineKey: 'paymentRate',
                    style: 'width: 95px;'
                },
                {
                    label: this.$t('boss.purchase.source_no',{defaultValue:'来源单号'}),
                    tag: 'vInput',
                    key: 'CN_inboundRefNo',
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.batch_number',{defaultValue:'批次号'}),
                    tag: 'vInput',
                    key: 'CN_refNo',
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.currency',{defaultValue:'币种'}),
                    tag: 'vSelect',
                    key: 'EQ_currency',
                    options: this.getAllCurrency,
                    props: {
                        filterable: true,
                    },
                    style: stylewidth,
                },
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'EQ_poOrderItem.erpsku',
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.supplier_name',{defaultValue:'供应商名称'}),
                    tag: 'Select',
                    key: 'IN_supplierId',
                    options: this.getAllSupplier.map(item => {
                        return {
                            value: item.value,
                            label: `${item.label}(${item.attach.code})`
                        }
                    }),
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.request_form',{defaultValue:'关联采购申请单'}),
                    tag: 'vInput',
                    key: 'CN_poPurchaseRelateEntityList.poRequisitionOrderNo',
                    style: stylewidth,
                },


                {
                    label: this.$t('boss.purchase.procurement_model',{defaultValue:'采购模式'}),
                    tag: 'vSelect',
                    key: 'IN_paymentType',
                    style: stylewidth,
                    options: this.buyModeList,
                    props: {
                        multiple: true
                    }
                },
                {
                    label: this.$t('boss.purchase.exception_type',{defaultValue:'异常类型'}),
                    tag: 'vSelect',
                    key: 'EQ_errorCode',
                    style: stylewidth,
                    options: [{
                        value: 0,
                        label: this.$t('boss.purchase.no_abnormalities',{defaultValue:'无异常'})
                    }, {
                        value: 1,
                        label: this.$t('boss.purchase.abnormal_contract_form',{defaultValue:'合同单异常'})
                    }, {
                        value: 2,
                        label: this.$t('boss.purchase.abnormal_inventory_plan',{defaultValue:'入库计划单异常'})
                    }, {
                        value: 3,
                        label: this.$t('boss.purchase.update_inventory_plan',{defaultValue:'入库计划单更新成本异常'})
                    }, {
                        value: 4,
                        label: this.$t('boss.purchase.automatically_calculate_anomalies',{defaultValue:'自动计算异常'})
                    }, {
                        value: 5,
                        label: this.$t('boss.purchase.DingTalk_approval_exception',{defaultValue:'钉钉审批异常'})
                    }],
                    props: {
                        multiple: true
                    }
                },

                
                {
                    label: this.$t('boss.purchase.promise_delivery',{defaultValue:'承诺交货日期'}),
                    tag: 'vDatepicker',
                    key: 'GE_promiseDeliveryDate',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:210px"
                },
                {
                    label: this.$t('boss.purchase.warehouse',{defaultValue:'预计接收仓库'}),
                    tag: 'vSelect',
                    key: 'IN_expectedReceiveWarehouseId',
                    style: stylewidth,
                    options: this.getWarehouseAllList,
                    props: {
                        filterable: true,
                        multiple: true,
                    }
                },
                {
                    label: this.$t('boss.purchase.inspection_status',{defaultValue:'验货状态'}),
                    tag: 'vSelect',
                    key: 'EQ_inspectStatus',
                    style: stylewidth,
                    options: [
                        { value: 0, label: this.$t('boss.purchase.uninspected_goods',{defaultValue:'未验货'})},
                        { value: 1, label: this.$t('boss.purchase.qualified_inspection',{defaultValue:'验货合格'})},
                        { value: 2, label: this.$t('boss.purchase.unqualified_inspection',{defaultValue:'验货不合格'})},
                    ]
                },
                {
                    label: this.$t('boss.purchase.inspection_personnel',{defaultValue:'验货人员'}),
                    tag: 'vInput',
                    key: 'CN_inspectPersonName',
                    style: stylewidth,
                },


                {
                    label: this.$t('boss.purchase.notes',{defaultValue:'备注'}),
                    tag: 'vInput',
                    key: 'CN_remark',
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.created_at',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    key: 'GE_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:210px"
                },
                {
                    label: this.$t('boss.purchase.inventory_plan',{defaultValue:'入库计划单'}),
                    tag: 'vInput',
                    key: 'CN_inboundPlanNo',
                    style: stylewidth,
                },
                {
                    label: this.$t('boss.purchase.Firm_status',{defaultValue:'firm状态'}),
                    key: "EQ_poOrderItem.firmStatus",
                    tag: "vSelect",
                    options: [
                        {
                            label: "Y",
                            value: 1
                        },
                        {
                            label: "N",
                            value: 0
                        }
                    ],
                    style: stylewidth,
                }
            ]
        },
        columns() {
            let columns = [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                }, {
                    title: this.$t('boss.purchase.operate',{defaultValue:'操作'}),
                    width: 70,
                    render: this.getOperateNodes,
                }, {
                    title: this.$t('boss.purchase.batch_purchase_project',{defaultValue:'采购单编号/批次号/来源单号/项目'}),
                    width: 200,
                    render: (h, { row, index }) => {
                        const className = `copy_${row.orderNo}_${index}`;
                        const id = row.lineId;
                        const product = this.getNewDifferentAllProductList.filter((item) => {
                            return id == item.value
                        })[0] || {};
                        let firmArray = row.poOrderItem.filter(item => {
                            return item.firmStatus == 1;
                        });
                        let hasFirm = firmArray.length > 0;
                        return <div style="display: flex; justify-content: space-between;">
                            <div>
                                <a class={className} onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.orderNo}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-5 font-14" type="ios-browsers-outline" /></a>
                                <a title={this.$t("boss.purchase.click_copy_tracking",{defaultValue:"点击复制单号"})} onClick={() => this.handleCopy(`.${className}`)}><vIcon class="margin-left-5 font-14" type="copy" /></a>
                                <div>{row.refNo || '--'}</div>
                                <div>{row.inboundRefNo || '--'}</div>
                                <div>{product.label || '--'}</div>
                            </div>
                            <div v-show={hasFirm}>
                                <compLock size="20"></compLock>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t("boss.purchase.amount_currency",{defaultValue:"采购金额/币种"}),
                    width: 70,
                    key: 'amount',
                    sortable: true,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.amount}</div>
                            <div>{row.currency}</div>
                        </div>
                    }
                },

                {
                    title: this.$t("boss.purchase.document_status",{defaultValue:"单据状态"}),
                    width: 85,
                    align: 'center',
                    render: (h, { row }) => {
                        const status = row.orderStatus;
                        const { theme, label } = this.getOrderStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        let font = ''
                        switch (row.errorCode) {
                            case 1: font = this.$t("boss.purchase.abnormal_contract_a",{defaultValue:"(合同单异常)"}); break;
                            case 2: font = this.$t("boss.purchase.abnormal_inventory_plan_a",{defaultValue:"(入库计划单异常)"}); break;
                            case 3: font = this.$t("boss.purchase.cost_inventory_plan",{defaultValue:"(入库计划单更新成本异常)"}); break;
                            case 4: font = this.$t("boss.purchase.automatic_calculation_exception",{defaultValue:"(自动计算异常)"}); break;
                            case 5: font = this.$t("boss.purchase.DingTalk_approval_exception_a",{defaultValue:"(钉钉审批异常)"}); break;
                        }
                        return (
                            <div>
                                <vButton ghost theme={theme} size="small" class="cursor-default width-60">{label}</vButton>
                                <span class="color-error"><Tooltip max-width="200" content={row.errorMsg} placement='top'>{font}</Tooltip></span>
                            </div>
                        )

                    }
                },

                {
                    title: this.$t("boss.purchase.abnormal_contract_a",{defaultValue:"采购量"}),
                    width: 60,
                    key: 'allquty',
                    // sortable: true,
                    render: (h, { row }) => {
                        let allquty = 0;
                        row.poOrderItem.map(item => {
                            // allquty += item.quantity
                            allquty += Number(item.quantity - (item.cancelQuantity ? item.cancelQuantity : 0));
                        })
                        return <div>
                            <div>{allquty}</div>
                        </div>
                    }
                },

                {
                    title: this.$t("boss.purchase.inventory_plan_quantity",{defaultValue:"待创建入库计划量"}),
                    width: 70,
                    render: (h, { row }) => {
                        let allcompqty = 0;
                        row.poOrderItem.map(item => {
                            allcompqty += Number((item.quantity - (item.cancelQuantity ? item.cancelQuantity : 0)) - item.shipmentQuantity) > 0 ? Number((item.quantity - (item.cancelQuantity ? item.cancelQuantity : 0)) - item.shipmentQuantity) : 0;
                        })
                        return <div>
                            <div>{(allcompqty < 0 || row.orderStatus == 'canceled' || row.orderStatus == 'closed' || row.orderStatus == 'finished') ? 0 : allcompqty}</div>
                        </div>
                    }
                },

                {
                    title: this.$t("boss.purchase.delivery_quantity",{defaultValue:"交货量"}),
                    width: 90,
                    render: (h, { row }) => {
                        let allquty = 0, allcompqty = 0;
                        row.poOrderItem.map(item => {
                            // 实采数量
                            allquty += Number(item.quantity - (item.cancelQuantity ? item.cancelQuantity : 0));
                            // 已交货
                            allcompqty += item.deliverQuantity;
                            // allcompqty += (item.quantity - item.deliverQuantity) < 0 ? 0 : (item.quantity - item.deliverQuantity);
                            // allquty += item.deliverQuantity;
                        })
                        // 未交货
                        let notDeliverNum = allquty - allcompqty;
                        return <div>
                            <div>{this.$t("boss.purchase.delivered",{defaultValue:"已交货"})}:{(row.orderStatus == 'canceled' || row.orderStatus == 'closed') ? 0 : allcompqty}</div>
                            <div>{this.$t("boss.purchase.to_be_delivered",{defaultValue:"待交货"})}:{(notDeliverNum < 0 || row.orderStatus == 'canceled' || row.orderStatus == 'closed' || row.orderStatus == 'finished') ? 0 : notDeliverNum}</div>
                        </div>
                    }
                },

                {
                    title: this.$t("boss.purchase.receiving_quantity",{defaultValue:"接收量"}),
                    width: 90,
                    render: (h, { row }) => {
                        let allquty = 0, allcompqty = 0;
                        row.poOrderItem.map(item => {
                            allcompqty += (item.shipmentQuantity - (item.receiveAvailableQuantity + item.receiveUnavailableQuantity)) < 0 ? 0 : (item.shipmentQuantity - (item.receiveAvailableQuantity + item.receiveUnavailableQuantity));

                            allquty += (item.receiveAvailableQuantity + item.receiveUnavailableQuantity);
                        })
                        return <div>
                            <div>{this.$t("boss.purchase.received",{defaultValue:"已接收"})}:{allquty}</div>
                            <div>{this.$t("boss.purchase.to_be_received",{defaultValue:"待接收"})}:{(allcompqty < 0 || row.orderStatus == 'canceled' || row.orderStatus == 'closed' || row.orderStatus == 'finished') ? 0 : allcompqty}</div>
                            {/* <div>待接收:{allcompqty}</div> */}
                        </div>
                    }
                },

                {
                    title: this.$t("boss.purchase.inspection_results_a",{defaultValue:"验货结果/预计验货日期"}),
                    key: 'promiseDeliveryDate',
                    minWidth: 160,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.isNeedInspect == 1 ? (row.inspectStatus == 0 ? this.$t("boss.purchase.uninspected_goods",{defaultValue:"未验货"}) : row.inspectStatus == 1 ? this.$t("boss.purchase.qualified_inspection",{defaultValue:"验货合格"}) : this.$t("boss.purchase.unqualified_inspection",{defaultValue:"验货不合格"})) : '--'}</div>
                            <div>{row.expectedInspectDate || '--'}</div>
                        </div>
                    },
                    sortable: true,
                },

                {
                    title: this.$t("boss.purchase.supplier_a",{defaultValue:"供应商/承诺交货日期/最新预计交期"}),
                    key: 'promiseDeliveryDate',
                    minWidth: 150,
                    render: (h, { row }) => {
                        const id = row.supplierId;
                        const supplier = this.getAllSupplier.filter((item) => {
                            return id == item.value
                        })[0] || {};
                        return <div>
                            <div>{supplier.label}</div>
                            <div>{row.promiseDeliveryDate || '--'}</div>
                            <div v-show={!!row.expectedDeliveryDate}>{row.expectedDeliveryDate}<span style="margin-left: 5px; color: #ed4014;font-weight: bold;">!</span></div>
                        </div>
                    },
                    sortable: true,
                },
                {
                    title: this.$t("boss.purchase.inventory_plan_a",{defaultValue:"入库计划单/接收情况"}),
                    width: 150,
                    render: (h, { row }) => {
                        // let arrNos = [];
                        if (row.inboundPlanReceiveList) {
                            return (row.inboundPlanReceiveList || []).map(item => {
                                let jsonone = item.inboundPlanOrderNo + " (" + this.getinboundStatus(item.inboundPlanOrderStatus) + ")"
                                return <div><a onClick={this.handleOperates.bind(this, item.inboundPlanOrderId, 'jumpinbound')}>{jsonone}</a></div>
                            })
                        } else return '--'
                    }
                },

                {
                    title: this.$t("boss.purchase.other_information",{defaultValue:"其他信息"}),
                    width: 150,
                    render: (h, { row }) => {
                        let paymentTypeFont = this.buyModeList.filter(item => {
                            return item.value === row.paymentType
                        })[0] || {}
                        let funderId = row.poOrderFk ? row.poOrderFk.funderId : null
                        let funderName = this.funderList.filter(item => {
                            return item.id === funderId
                        })[0] || {}
                        funderName = funderName ? funderName.funderName : '--'
                        paymentTypeFont = paymentTypeFont ? paymentTypeFont.label : '--'

                        return <div>
                            <div>{this.$t("boss.purchase.procurement_model",{defaultValue:"采购模式"})}:{paymentTypeFont || '--'}</div>
                            <div>{this.$t("boss.purchase.contract_number",{defaultValue:"采购模式"})}:{row.poOrderFk ? row.poOrderFk.referenceNo : '--'}</div>
                            <div>{this.$t("boss.purchase.source_no",{defaultValue:"来源单号"})}:{row.inboundRefNo}</div>
                            <div>{this.$t("boss.purchase.funding_party",{defaultValue:"资金方"})}:{funderName || '--'}</div>
                        </div>
                    }
                },


                {
                    title: this.$t("boss.purchase.creation_time_a",{defaultValue:"创建时间/提交时间/审核通过时间"}),
                    key: 'createdAt',
                    minWidth: 100,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.createdAt || '--'}</div>
                            <div>{row.submitDate || '--'}</div>
                            <div>{row.auditingDate || '--'}</div>
                        </div>
                    }
                },
            ];
            // 待审核状态
            if (this.isShenhe) {
                columns = [
                    {
                        show: false,
                        type: 'selection',
                        width: 40,
                        align: 'center',
                        formName: 'id'
                    }, {
                        title: this.$t("boss.purchase.operate",{defaultValue:"操作"}),
                        width: 70,
                        render: this.getOperateNodes,
                    }, {
                        title: this.$t("boss.purchase.batch_purchase_project",{defaultValue:"采购单编号/批次号/来源单号/项目"}),
                        width: 200,
                        render: (h, { row, index }) => {
                            const className = `copy_${row.orderNo}_${index}`;
                            const id = row.lineId;
                            const product = this.getNewDifferentAllProductList.filter((item) => {
                                return id == item.value
                            })[0] || {};
                            return <div>
                                <a class={className} onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.orderNo}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-5 font-14" type="ios-browsers-outline" /></a>
                                <a title={this.$t("boss.purchase.click_copy_tracking",{defaultValue:"点击复制单号"})} onClick={() => this.handleCopy(`.${className}`)}><vIcon class="margin-left-5 font-14" type="copy" /></a>
                                <div>{row.refNo || '--'}</div>
                                <div>{row.inboundRefNo || '--'}</div>
                                <div>{product.label || '--'}</div>
                            </div>
                        }
                    },
                    {
                        title: this.$t("boss.purchase.amount_currency",{defaultValue:"采购金额/币种"}),
                        width: 70,
                        key: 'amount',
                        sortable: true,
                        render: (h, { row }) => {
                            return <div>
                                <div>{row.amount}</div>
                                <div>{row.currency}</div>
                            </div>
                        }
                    },
    
                    {
                        title: this.$t("boss.purchase.document_status",{defaultValue:"单据状态"}),
                        width: 85,
                        align: 'center',
                        render: (h, { row }) => {
                            const status = row.orderStatus;
                            const { theme, label } = this.getOrderStatus.find(function (item) {
                                return item.value == status
                            }) || {};
                            let font = ''
                            switch (row.errorCode) {
                                case 1: font = this.$t("boss.purchase.abnormal_contract_a",{defaultValue:"(合同单异常)"}); break;
                                case 2: font = this.$t("boss.purchase.abnormal_inventory_plan_a",{defaultValue:"(入库计划单异常)"}); break;
                                case 3: font = this.$t("boss.purchase.cost_inventory_plan",{defaultValue:"(入库计划单更新成本异常)"}); break;
                                case 4: font = this.$t("boss.purchase.automatic_calculation_exception",{defaultValue:"(自动计算异常)"}); break;
                                case 5: font = this.$t("boss.purchase.DingTalk_approval_exception_a",{defaultValue:"(钉钉审批异常)"}); break;
                            }
                            return (
                                <div>
                                    <vButton ghost theme={theme} size="small" class="cursor-default width-60">{label}</vButton>
                                    <span class="color-error"><Tooltip content={row.errorMsg} placement='top'>{font}</Tooltip></span>
                                </div>
                            )
    
                        }
                    },
    
                    {
                        title: this.$t("boss.purchase.order_quantity",{defaultValue:"采购量"}),
                        width: 60,
                        key: 'allquty',
                        // sortable: true,
                        render: (h, { row }) => {
                            let allquty = 0;
                            row.poOrderItem.map(item => {
                                // allquty += item.quantity
                                allquty += Number(item.quantity - (item.cancelQuantity ? item.cancelQuantity : 0));
                            })
                            return <div>
                                <div>{allquty}</div>
                            </div>
                        }
                    },
    
                    {
                        title: this.$t("boss.purchase.inspection_results_a",{defaultValue:"验货结果/预计验货日期"}),
                        key: 'promiseDeliveryDate',
                        minWidth: 160,
                        render: (h, { row }) => {
                            return <div>
                                <div>{row.isNeedInspect == 1 ? (row.inspectStatus == 0 ? this.$t("boss.purchase.uninspected_goods",{defaultValue:"未验货"}) : row.inspectStatus == 1 ? this.$t("boss.purchase.qualified_inspection",{defaultValue:"验货合格"}) : this.$t("boss.purchase.unqualified_inspection",{defaultValue:"验货不合格"})) : '--'}</div>
                                <div>{row.expectedInspectDate || '--'}</div>
                            </div>
                        },
                        sortable: true,
                    },
    
                    {
                        title: this.$t("boss.purchase.supplier_a",{defaultValue:"供应商/承诺交货日期/最新预计交期"}),
                        key: 'promiseDeliveryDate',
                        minWidth: 150,
                        render: (h, { row }) => {
                            const id = row.supplierId;
                            const supplier = this.getAllSupplier.filter((item) => {
                                return id == item.value
                            })[0] || {};
                            return <div>
                                <div>{supplier.label}</div>
                                <div>{row.promiseDeliveryDate || '--'}</div>
                                <div v-show={!!row.expectedDeliveryDate}>{row.expectedDeliveryDate}<span style="margin-left: 5px; color: #ed4014;font-weight: bold;">!</span></div>
                            </div>
                        },
                        sortable: true,
                    },
    
                    {
                        title: this.$t("boss.purchase.other_information",{defaultValue:"其他信息"}),
                        width: 150,
                        render: (h, { row }) => {
                            let paymentTypeFont = this.buyModeList.filter(item => {
                                return item.value === row.paymentType
                            })[0] || {}
                            let funderId = row.poOrderFk ? row.poOrderFk.funderId : null
                            let funderName = this.funderList.filter(item => {
                                return item.id === funderId
                            })[0] || {}
                            funderName = funderName ? funderName.funderName : '--'
                            paymentTypeFont = paymentTypeFont ? paymentTypeFont.label : '--'
    
                            return <div>
                                <div>{this.$t("boss.purchase.procurement_model",{defaultValue:"采购模式"})}:{paymentTypeFont || '--'}</div>
                                <div>{this.$t("boss.purchase.contract_number",{defaultValue:"合同编号"})}:{row.poOrderFk ? row.poOrderFk.referenceNo : '--'}</div>
                                <div>{this.$t("boss.purchase.source_no",{defaultValue:"来源单号"})}:{row.inboundRefNo}</div>
                                <div>{this.$t("boss.purchase.funding_party",{defaultValue:"资金方"})}:{funderName || '--'}</div>
                            </div>
                        }
                    },
                    {
                        title: this.$t("boss.purchase.approval_method",{defaultValue:"审批方式"}),
                        width: 80,
                        render: (h, { row }) => {
                            let str = row.dingProcessEnable == 1 ? this.$t("boss.purchase.DingTalk",{defaultValue:"钉钉"}) : this.$t("boss.purchase.intrasystem",{defaultValue:"系统内"});
                            return <div>{str}</div>
                        }
                    },
                    {
                        title: this.$t("boss.purchase.creation_time_a",{defaultValue:"创建时间/提交时间/审核通过时间"}),
                        key: 'createdAt',
                        minWidth: 100,
                        render: (h, { row }) => {
                            return <div>
                                <div>{row.createdAt || '--'}</div>
                                <div>{row.submitDate || '--'}</div>
                                <div>{row.auditingDate || '--'}</div>
                            </div>
                        }
                    },
                ]
            }
            return columns;
        },

    },

};
